import { render, staticRenderFns } from "./Violation.vue?vue&type=template&id=3095edff&scoped=true&"
import script from "./Violation.vue?vue&type=script&lang=js&"
export * from "./Violation.vue?vue&type=script&lang=js&"
import style0 from "./Violation.vue?vue&type=style&index=0&id=3095edff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095edff",
  null
  
)

export default component.exports